<h3 mat-dialog-title>{{ title }}</h3>

<mat-dialog-content>
  @if (showMessageAsBody) {
    <p class="dialog-message">{{ data.message }}</p>
  }

  @if (safeImageUrl) {
    <div class="dialog-image-wrap">
      @if (imageLoading) {
        <mat-spinner diameter="48" class="dialog-image-spinner"></mat-spinner>
      }
      <img
        [src]="safeImageUrl"
        alt=""
        class="dialog-image"
        [class.loaded]="!imageLoading"
        (load)="onImageLoad()"
        (error)="onImageError()"
        />
      </div>
    }

    @if (safeHtml) {
      <div class="dialog-html" [innerHTML]="safeHtml"></div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (data.route) {
      <button mat-raised-button mat-dialog-close="true" color="accent" [routerLink]="data.route">
        OK
      </button>
    }
    @if (!data.route) {
      <button mat-raised-button mat-dialog-close="true" color="accent">OK</button>
    }
  </mat-dialog-actions>
